jQuery(function ($) {
  var detailBoxSwiper;
  $.DetailBoxSwiper = function () {
  };

  $.DetailBoxSwiper.prototype = {
    /**
     * @method init
     * @desc initialize this module depending on the client
     */
    init: function () {
      var parent = this;

      // Update Swiper elements on tab click
      $('#detailbox a[data-toggle="tab"]').on('click', function () {
        var swiperInstance;
        var tabId;
        var tabContainer;

        // get tab container by id
        tabId = $(this).attr('href');
        tabContainer = $('.tab-pane' + tabId);

        // get swiper instance
        swiperInstance = tabContainer.find('.scroll-container-swiper').data('ScrollContainerSwiper');

        if (typeof swiperInstance !== 'undefined') {
          parent.updateSwiper(swiperInstance);
        }
      });

      $('.detailbox .no-scrolling').on('click', function () {
        $(this).remove();
      });
    },

    /**
     * @method updateSwiper
     * @desc update swiper instance with timeout
     */
    updateSwiper: function (swiper) {
      setTimeout(function () {
        swiper.update();
      }, 10);
    }
  };

  detailBoxSwiper = new $.DetailBoxSwiper();
  detailBoxSwiper.init();
});
